import { Modal, Header, Box } from "@amzn/awsui-components-react";
import ErrorContentRenderer from "../cbe/ErrorContentRenderer";
import { ErrorDetails, ErrorRecord } from "../../types/errors";
import ModalFooter from "../common/ModalFooter";
import { useCallback, useContext, useState } from "react";
import { StageContext } from "../../contexes/OrderIdContext";
import { useMarketplaceId } from "../../contexes/MarketplaceIdContext";

interface ErrorModalProps {
  visible: boolean;
  onDismiss: () => void;
  errorType: string;
  errorMessage: string;
  stackTrace: string | undefined;
}

export function ErrorModal({
  visible,
  onDismiss,
  errorType,
  errorMessage,
  stackTrace,
}: ErrorModalProps) {
  const errorDetails = {
    errorType,
    displayMessage: stackTrace,
    parsedErrorDetails: {
      errorType,
      errorMessage,
    },
    stackTrace,
  } as ErrorDetails;

  const [expandAll, setExpandAll] = useState(true);
  const handleExpandAll = useCallback(() => setExpandAll((prev) => !prev), []);

  return (
    <Modal
      className="error-modal"
      onDismiss={onDismiss}
      visible={visible}
      closeAriaLabel="Close modal"
      size="max"
      footer={
        <ModalFooter
          stackTrace={errorDetails.stackTrace}
          inputRequestUrl={errorDetails.inputRequestUrl}
          onClose={onDismiss}
          onExpandToggle={handleExpandAll}
          expandAll={expandAll}
        />
      }
      header={
        <Header variant="h2">
          Error Type: {errorType || "Unknown type"}: {errorMessage || "Unknown message"}
        </Header>
      }
    >
      <ErrorContentRenderer
        errorDetails={errorDetails}
        isModalVisible={visible}
        expandAll={expandAll}
      />
    </Modal>
  );
}
